module.exports = __webpack_public_path__ + "media/images/athletes/2916-07ccc8b24570db509248365de74a0966.png";